// extracted by mini-css-extract-plugin
export var link = "hx_R";